import React, { useState, createContext, useContext } from 'react';
type BoardContextType = {
  selectedIndex: number;
  setSelectedIndex: (idx: number) => void;
};
const BoardContext = createContext<BoardContextType>({
  selectedIndex: 0,
  setSelectedIndex: () => {}
});
export function BoardProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  return <BoardContext.Provider value={{
    selectedIndex,
    setSelectedIndex
  }} data-id="element-118">
      {children}
    </BoardContext.Provider>;
}
export function useBoardContext() {
  return useContext(BoardContext);
}